<template>
  <Modal
    ref="deleteProductModalRef"
    @onNegativeActionClick="closeDeleteProductModal"
    @onPositiveActionClick="deleteProducts"
    :isPositiveActionPending="isDeleteProductsLoading"
    :isPositiveActionButtonDisabled="isDeleteProductsLoading"
    negativeActionText="Vazgeç"
    positiveActionText="Ürünleri Sil"
    :title="titleChangeWithStatus"
    class="deleteProductModal"
  >
    <template v-slot:body>
      <template v-if="!productStatus.includes('InApproval')">
        <p>Ürünler ile birlikte aşağıdaki bilgiler de silinecektir:</p>
        <ul class="deleteProductModal-list">
          <li><b>Ürünlerin geçmiş kampanya bilgileri</b></li>
          <li><b>Ürün bazlı iade adresi</b></li>
        </ul>
        <p class="deleteProductModal-bottomText">
          (Ürün bazlı iade adresi, ürünlerle birlikte silineceği için iadeler
          ana adresinize yapılacaktır.)
        </p>
      </template>
      <template v-else>
        <p class="modal-text">
          Seçili ürünler silinecektir.<br />
          Ürünleri doğru bilgilerle tekrar katalog onayına <br />
          gönderebilirsiniz.
        </p>
      </template>
    </template>
  </Modal>
</template>

<script setup>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { Modal } from "@n11/so-ui-components";
import { sendProductsDeletedEvent } from "@/utils/ga4/helper";
import { ToastMessageTypes } from "@/utils/enum/toastMessageTypes";

const props = defineProps({
  getSelectedRows: {
    type: Array,
    required: false,
    default: [],
  },
  tabParam: {
    type: String,
    required: false,
    default: "",
  },
  productStatus: {
    type: Array,
    required: false,
    default: [],
  },
});

const emit = defineEmits(["successDeleteProduct"]);

const store = useStore();
const deleteProductModalRef = ref();
const isDeleteProductsLoading = ref(false);

const openDeleteProductModal = () => deleteProductModalRef?.value?.openModal();

const closeDeleteProductModal = () =>
  deleteProductModalRef?.value?.hiddenModal();
const titleChangeWithStatus = computed(() =>
  props.productStatus.includes("InApproval")
    ? "Ürünleri silmek istediğinize emin misiniz?"
    : "Seçili ürünleri silmek istediğinize emin misiniz?"
);

const messageType = (data) => {
  const hasFailed = data?.failProductIds?.length > 0;
  const hasSucceeded = data?.successProductIds?.length > 0;

  if (hasFailed && hasSucceeded) {
    return ToastMessageTypes.WARNING;
  }
  if (hasFailed) {
    return ToastMessageTypes.ERROR;
  }
  if (hasSucceeded) {
    return ToastMessageTypes.SUCCESS;
  }
  return false;
};

const deleteProducts = async () => {
  const pids = Object.keys(props.getSelectedRows);
  const tabParam = props.tabParam;
  const productStatus = props.productStatus;
  const payload = {
    productIds: pids,
    ...(productStatus.includes("InApproval") && { tabParam }),
  };
  isDeleteProductsLoading.value = true;
  try {
    const res = await store.dispatch("products/deleteProducts", payload);
    emit("successDeleteProduct");
    store.commit("common/SET_TOASTER_DATA", {
      type: messageType(res.data),
      description: res.data?.message,
    });

    sendProductsDeletedEvent({ quantity: pids.length });
  } catch (error) {
    console.error(error);
    store.commit("common/SET_TOASTER_DATA", {
      type: ToastMessageTypes.ERROR,
      title: ToastMessageTypes.ERROR_TITLE,
      description: ToastMessageTypes.ERROR_DELETE_DESCRIPTION,
    });
  } finally {
    isDeleteProductsLoading.value = false;
    closeDeleteProductModal();
  }
};

defineExpose({
  openDeleteProductModal,
});
</script>

<style lang="scss" scoped>
.deleteProductModal {
  &-list {
    list-style-type: disc;
    list-style-position: inside;
    display: grid;
    gap: 6px;
    font-weight: 600;
  }

  &-bottomText {
    margin-bottom: 12px;
  }
}
.modal-text {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.05px;
}
</style>
